"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ResourceAvailabilityCalendar = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const styled_1 = __importDefault(require("@emotion/styled"));
const react_1 = require("react");
const utils_1 = require("@bemlo/utils");
const Row_1 = require("./Row");
const constants_1 = require("../../../constants");
const elements_1 = require("../../../elements");
const translate_1 = require("../../../translate");
const shift_hours_styles_1 = require("../../../utils/shift-hours-styles");
const Grid = styled_1.default.div({
    display: 'grid',
    gridTemplateColumns: 'max-content 3fr 3fr 3fr 40px',
    gridAutoRows: 45,
    gridGap: constants_1.theme.spacing[2],
});
const DAY_STYLES = shift_hours_styles_1.SHIFT_HOURS_STYLES['DAY'];
const EVENING_STYLES = shift_hours_styles_1.SHIFT_HOURS_STYLES['EVENING'];
const NIGHT_STYLES = shift_hours_styles_1.SHIFT_HOURS_STYLES['NIGHT'];
const ShiftTypeHeader = (props) => {
    return ((0, jsx_runtime_1.jsxs)(elements_1.Flex, { gap: 1, items: "center", styles: { color: props.color, justifyContent: 'center', mr: 2 }, children: [(0, jsx_runtime_1.jsx)(elements_1.Icon, { name: props.icon }), (0, jsx_runtime_1.jsx)(elements_1.Text, { bold: true, children: props.label })] }));
};
const Header = () => {
    const t = (0, translate_1.useTranslations)();
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(elements_1.Div, {}), (0, jsx_runtime_1.jsx)(ShiftTypeHeader, { ...DAY_STYLES, label: t.shifts.day() }), (0, jsx_runtime_1.jsx)(ShiftTypeHeader, { ...EVENING_STYLES, label: t.shifts.twilight() }), (0, jsx_runtime_1.jsx)(ShiftTypeHeader, { ...NIGHT_STYLES, label: t.shifts.night() }), (0, jsx_runtime_1.jsx)(elements_1.Div, {})] }));
};
const ResourceAvailabilityCalendar = (props) => {
    const [defaultTime, setDefaultTime] = (0, react_1.useState)({
        startTime: '07:00',
        endTime: '22:00',
    });
    const days = (0, react_1.useMemo)(() => {
        const daysInMonth = props.month.daysInMonth();
        const days = [];
        for (let i = 0; i < daysInMonth; i++) {
            const availability = props.availability.filter(({ startDateTime }) => props.month.add(i, 'day').isSame(startDateTime, 'day'));
            const booking = props.bookings.find(({ startDateTime }) => props.month.add(i, 'day').isSame(startDateTime, 'day'));
            days.push({ day: props.month.add(i, 'day'), availability, booking });
        }
        return days;
    }, [props.month, props.bookings, props.availability]);
    return ((0, jsx_runtime_1.jsxs)(Grid, { children: [(0, jsx_runtime_1.jsx)(Header, {}), days.map(({ day, availability, booking }) => ((0, jsx_runtime_1.jsx)(Row_1.Row, { day: day, onCreateExactAvailability: props.onCreateExactAvailability, onUpdateExactAvailability: props.onUpdateExactAvailability, onDelete: (ids) => props.onDelete((0, utils_1.toArray)(ids)), onMarkAsAvailable: (shiftHours) => props.onMarkAsAvailable(day, shiftHours), onMarkAsUnavailable: props.onMarkAsUnavailable, availability: availability, defaultTimes: defaultTime, setDefaultTime: setDefaultTime, booking: booking }, day.format())))] }));
};
exports.ResourceAvailabilityCalendar = ResourceAvailabilityCalendar;
